
import Cookies from 'js-cookie';
  export async function handle401Error(cookieNames) {
    try {
      await Promise.all(cookieNames?.map((cookieName) => Cookies.remove(cookieName)));
    } catch (error) {
      return;
    }
  }